// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "* {\n  padding: 0;\n  margin: 0;\n}\n#app {\n  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, \"\\5FAE\\8F6F\\96C5\\9ED1\", Arial, sans-serif;\n  line-height: 1.5;\n  font-size: 2.933vw;\n  color: #515a6e;\n}\n", ""]);
// Exports
module.exports = exports;
